// https://magnetic.cisco.com/0a43ab5cd/p/848e17-empty-state
// Keeping this for now; can potentially merge with src/modules/components/EmptyBox React component
export default {
  name: 'dashify:EmptyBox',
  title: 'Empty Box',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'EmptyBox'],
  spec: {
    props: {
      message: 'No data',
    },
    view: [
      [
        'div',
        {
          '.': 'flex justify-center items-center h-full rounded-lg py-4 bg-default-bg-medium',
        },
        [
          [
            'p',
            {
              '.': 'text-center text-default-text-medium',
              style: {
                font: 'var(--typography-p3-default)',
              },
            },
            '/${props.message}',
          ],
        ],
      ],
    ],
  },
};
